import { page } from "@routes/routeModule";

export const DashboardLayout = page(
  () => import("@layouts/Dashboard/Dashboard"),
);
export const ProgramLayout = page(
  () => import("@Programs/layout/ProgramLayoutPage"),
);
export const PatientProgramLayoutPage = page(
  () => import("@PatientPrograms/layout/PatientProgramLayout"),
);

export const ActivationPage = page(
  () => import("@/packages/auth/Activation/ActivationPage"),
);
export const LinkResendPage = page(
  () => import("@/packages/auth/Activation/LinkResendPage"),
);
export const RegisterPatientPage = page(
  () => import("@/packages/auth/RegisterPatient/RegisterPatientPage"),
);
export const OrderPage = page(
  () => import("@/packages/storeOrder/components/OrderPage"),
);
export const PublicClinicPage = page(
  () => import("@/packages/publicStorefront/PublicClinicPage"),
);
export const PublicProductPage = page(
  () => import("@/packages/publicBooking/PublicProductPage"),
);
export const PublicBookingEntryPage = page(
  () => import("@/packages/publicBooking/PublicBookingEntryPage"),
);
export const VisitCancelPage = page(
  () => import("@/packages/auth/Visit/VisitCancelPage"),
);
export const VisitConfirmPage = page(
  () => import("@/packages/auth/Visit/VisitConfirmPage"),
);
export const RecoveryPage = page(
  () => import("@/packages/auth/Recovery/RecoveryPage"),
);
export const QuestionnaireAnswerPage = page(
  () => import("@Questionnaires/survey/pages/QuestionnaireAnswerPage"),
);

export const Error404Page = page(
  () => import("@Core/components/emptyStates/Error404/Error404Page"),
);

export const HomePage = page(() => import("@/packages/dashboard/HomePage"));
export const CalendarPage = page(
  () => import("@Calendar/components/CalendarPage"),
);
export const ClientsPage = page(
  () => import("@Clients/components/ClientsPage"),
);
export const ChatPage = page(() => import("@/packages/chat/ChatPage"));
export const PatientFilesPage = page(
  () => import("@/packages/patientFiles/PatientFilesPage"),
);
export const ClientProfilePage = page(
  () => import("@/packages/patientProfile/ClientProfilePage"),
);
export const PatientVisitsPage = page(
  () => import("@/packages/patientVisits/PatientVisitsPage"),
);
export const PatientBalancePage = page(
  () => import("@/packages/patientBalance/pages/PatientBalancePage"),
);
export const ClientHealthNewPage = page(
  () => import("@/packages/patientHealth/ClientHealthNewPage"),
);
export const PatientMonitoringNewPage = page(
  () => import("@/packages/patientMonitoring/PatientMonitoringNewPage"),
);
export const PatientProgramsPage = page(
  () => import("@PatientPrograms/pages/PatientProgramsPage"),
);
export const PatientProgramPage = page(
  () => import("@PatientPrograms/program/PatientProgramPage"),
);
export const PatientSharedPage = page(
  () => import("@/packages/patientSharedContent/PatientSharedPage"),
);
export const PatientSharedCollectionsPage = page(
  () =>
    import("@/packages/patientSharedContent/pages/PatientSharedCollectionsPage"),
);
export const PatientSharedDietsPage = page(
  () => import("@/packages/patientSharedContent/pages/PatientSharedDietsPage"),
);
export const PatientSharedRecipesPage = page(
  () =>
    import("@/packages/patientSharedContent/pages/PatientSharedRecipesPage"),
);
export const PatientSharedEducationalMaterialsPage = page(
  () =>
    import("@/packages/patientSharedContent/pages/PatientSharedEducationalMaterialsPage"),
);
export const PatientProgramChoicePage = page(
  () => import("@PatientProgramChoice/components/PatientProgramChoicePage"),
);
export const StartCollaborationPage = page(
  () => import("@PatientPrograms/pages/StartCollaborationPage"),
);
export const PatientSurveyAnswerPage = page(
  () => import("@Questionnaires/survey/pages/PatientSurveyAnswerPage"),
);
export const AiNotesPage = page(() => import("@/packages/aiNotes/AiNotesPage"));
export const AiOnboardingPage = page(
  () => import("@/packages/aiOnboarding/AiOnboardingPage"),
);

export const ProgramEditPage = page(
  () => import("@Programs/edit/ProgramEditPage"),
);
export const ProgramCopyPage = page(
  () => import("@Programs/edit/ProgramCopyPage"),
);
export const PatientProgramDaysPage = page(
  () => import("@Programs/days/PatientProgramDaysPage"),
);
export const ClientProgramSchedulePage = page(
  () => import("@/packages/programSchedule/ClientProgramSchedulePage"),
);
export const ProgramDietsNewPage = page(
  () => import("@Programs/dietsNew/ProgramDietsNewPage"),
);
export const ProgramPage = page(() => import("@Programs/show/ProgramPage"));
export const ProgramsPage = page(
  () => import("@Programs/components/ProgramsPage"),
);
export const ProgramCreatorBootstrapPage = page(
  () => import("@PatientPrograms/creator/ProgramCreatorBootstrapPage"),
);
export const ProgramCreatorPage = page(
  () => import("@PatientPrograms/creator/ProgramCreatorPage"),
);
export const ProgramSettingsPage = page(
  () => import("@PatientPrograms/creator/steps/settings/ProgramSettingsPage"),
);
export const ProgramAssumptionsPage = page(
  () => import("@PatientPrograms/creator/steps/ProgramAssumptionsPage"),
);
export const ProgramRecipesPage = page(
  () => import("@PatientPrograms/creator/steps/ProgramRecipesPage"),
);
export const ProgramMealPlanPage = page(
  () => import("@PatientPrograms/creator/steps/ProgramMealPlanPage"),
);
export const ProgramCreatorSchedulePage = page(
  () => import("@PatientPrograms/creator/steps/ProgramSchedulePage"),
);
export const ScheduleRecipeEditPage = page(
  () =>
    import("@/packages/programSchedule/scheduleRecipe/ScheduleRecipeEditPage"),
);

export const DietsPage = page(() => import("@Diets/components/DietsPage"));
export const DietCreatorPage = page(
  () => import("@Diets/creator/DietCreatorPage"),
);
export const DietClonePage = page(() => import("@Diets/creator/DietClonePage"));
export const DietCreatorSettingsPage = page(
  () => import("@Diets/creator/components/SettingsTab/DietCreatorSettingsPage"),
);
export const DietCreatorRecipesPage = page(
  () => import("@Diets/creator/components/RecipesTab/DietCreatorRecipesPage"),
);
export const DietCreatorProductsPage = page(
  () => import("@Diets/creator/components/ProductsTab/DietCreatorProductsPage"),
);
export const DietCreatorTagsPage = page(
  () => import("@Diets/creator/components/TagsTab/DietCreatorTagsPage"),
);
export const DietPage = page(() => import("@Diets/components/DietPage"));

export const MealPage = page(
  () => import("@Meals/components/MealShowPage/MealShowPage"),
);
export const MealNewPage = page(() => import("@Meals/components/MealNewPage"));
export const MealEditPage = page(
  () => import("@Meals/components/MealEditPage"),
);
export const MealCopyPage = page(
  () => import("@Meals/components/MealCopyPage"),
);
export const MealHeaderLayout = page(
  () => import("@Meals/components/MealHeaderLayout"),
);
export const MealsPage = page(() => import("@Meals/components/MealsPage"));

export const RecipesPage = page(
  () => import("@Recipes/components/RecipesPage"),
);
export const RecipePage = page(
  () => import("@Recipes/components/RecipeShowPage/RecipeShowPage"),
);
export const RecipeNewPage = page(
  () => import("@Recipes/components/RecipeNewPage"),
);
export const RecipeEditPage = page(
  () => import("@Recipes/components/RecipeEditPage"),
);
export const RecipeCopyPage = page(
  () => import("@Recipes/components/RecipeCopyPage"),
);
export const RecipeHeaderLayout = page(
  () => import("@Recipes/components/RecipeHeaderLayout"),
);

export const ProductsPage = page(
  () => import("@/packages/products/components/ProductsPage"),
);
export const ProductNewPage = page(
  () => import("@Products/components/ProductNewPage"),
);
export const ProductViewPage = page(
  () => import("@Products/components/ProductViewPage"),
);
export const ProductEditPage = page(
  () => import("@Products/components/ProductEditPage"),
);
export const ProductCopyPage = page(
  () => import("@Products/components/ProductCopyPage"),
);
export const ProductHeaderLayout = page(
  () => import("@Products/components/ProductHeaderLayout"),
);

export const AccountSettingsPage = page(
  () => import("@Settings/account/AccountSettingsPage"),
);
export const AccountProfilePage = page(
  () => import("@Settings/account/AccountProfilePage"),
);
export const AccountSecurityPage = page(
  () => import("@Settings/account/AccountSecurityPage"),
);
export const AccountPreferencesPage = page(
  () => import("@Settings/account/AccountPreferencesPage"),
);
export const AccountIntegrationsPage = page(
  () => import("@Settings/integrations/AccountIntegrationsPage"),
);
export const AccountSchedulePage = page(
  () => import("@/packages/availability/pages/AccountSchedulePage"),
);
export const CooperationSettingsPage = page(
  () =>
    import("@/packages/patientHealth/cooperationSettings/CooperationSettingsPage"),
);
export const SectionsPage = page(
  () => import("@Sections/components/SectionsPage"),
);
export const SectionDetailPage = page(
  () => import("@Sections/components/SectionDetailPage"),
);
export const TasksAndNotesPage = page(
  () => import("@/packages/tasks/pages/TasksAndNotesPage"),
);

export const TasksPage = page(() => import("@/packages/tasks/pages/TasksPage"));

export const NotesPage = page(() => import("@/packages/tasks/pages/NotesPage"));

export const QuestionnairesPage = page(
  () => import("@Questionnaires/management/components/QuestionnairesPage"),
);
export const QuestionnaireEditPage = page(
  () => import("@Questionnaires/edit/QuestionnaireEditPage"),
);
export const CallbackPage = page(
  () => import("@Settings/integrations/CallbackPage"),
);
export const ActivityHistoryPage = page(
  () => import("@Settings/activityHistory/ActivityHistoryPage"),
);

export const PricingPage = page(
  () => import("@/packages/pricing/plans/PricingPage"),
);
export const PurchaseConfiguratorPage = page(
  () => import("@/packages/pricing/configurator/PurchaseConfiguratorPage"),
);
export const ServiceConfiguratorPage = page(
  () =>
    import("@/packages/pricing/configurator/ServiceConfigurator/ServiceConfiguratorPage"),
);

export const SalesProductsPage = page(
  () => import("@/packages/salesProducts/pages/SalesProductsPage"),
);
export const SalesProductEditorPage = page(
  () => import("@/packages/salesProducts/pages/SalesProductEditorPage"),
);
export const SalesStorefrontPage = page(
  () => import("@/packages/salesStorefront/pages/SalesStorefrontPage"),
);
export const SalesPurchasesPage = page(
  () => import("@/packages/salesPurchases/pages/SalesPurchasesPage"),
);

export const OfficesPage = page(
  () => import("@Settings/components/OfficesTab/OfficesPage"),
);
export const KeysPage = page(
  () => import("@Settings/components/KeysTab/KeysPage"),
);
export const ClinicSettingsPage = page(
  () => import("@Settings/clinic/ClinicSettingsPage"),
);
export const ClinicGeneralPage = page(
  () => import("@Settings/clinic/general/ClinicGeneralPage"),
);
export const ClinicPaymentsPage = page(
  () => import("@Settings/clinic/payments/ClinicPaymentsPage"),
);
export const ClinicBillingPage = page(
  () => import("@Settings/clinic/billing/ClinicBillingPage"),
);
export const ClinicPlanPage = page(
  () => import("@Settings/clinic/plan/ClinicPlanPage"),
);
export const DietitianInvoicesPage = page(
  () => import("@Settings/components/InvoicesPage/InvoicesPage"),
);
export const EmployeesPage = page(
  () => import("@Settings/components/EmployeesTab/EmployeesPage"),
);

export const ClientPage = page(() => import("@Clients/ClientPage/ClientPage"));
export const ClientProgramHeaderLayout = page(
  () => import("@PatientPrograms/program/ClientProgramHeaderLayout"),
);

export const PatientProgramDay = page(
  () => import("@/packages/programs/days/PatientProgramDay"),
);

export const ResetPasswordPatientPage = page(
  () => import("@/packages/auth/ResetPassword/ResetPasswordPatientPage"),
);
export const StorePasswordPatientPage = page(
  () => import("@/packages/auth/StorePassword/StorePasswordPatientPage"),
);
